import { render, staticRenderFns } from "./TenantFAQ.vue?vue&type=template&id=3d888fc4&scoped=true&"
import script from "./TenantFAQ.vue?vue&type=script&lang=ts&"
export * from "./TenantFAQ.vue?vue&type=script&lang=ts&"
import style0 from "./TenantFAQ.vue?vue&type=style&index=0&id=3d888fc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d888fc4",
  null
  
)

export default component.exports